var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18326 23.2332V19.6554C9.18323 18.7453 9.92514 18.0059 10.8444 17.9998H14.2114C15.135 17.9998 15.8838 18.741 15.8838 19.6554V19.6554V23.2443C15.8835 24.017 16.5065 24.6485 17.2867 24.6666H19.5314C21.7692 24.6666 23.5832 22.8707 23.5832 20.6554V20.6554V10.4774C23.5712 9.60588 23.1579 8.78749 22.4608 8.25512L14.7838 2.13277C13.4389 1.06675 11.5271 1.06675 10.1822 2.13277L2.53887 8.26623C1.83914 8.79644 1.42512 9.61619 1.4165 10.4885V20.6554C1.4165 22.8707 3.23053 24.6666 5.46823 24.6666H7.71296C8.51258 24.6666 9.16081 24.0248 9.16081 23.2332V23.2332",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTabIcon);
export default __webpack_public_path__ + "static/media/homeTabIcon.5f669c6db24654dba4844ae1f9cba72a.svg";
export { ForwardRef as ReactComponent };